import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppService } from '../services/app.service';
import { toSignal } from '@angular/core/rxjs-interop';

export const organizationNotInitializedGuard: CanActivateChildFn = (_childRoute, _state) => {
    const router = inject(Router);
    const appContextService = inject(AppService);
    const organization = toSignal(appContextService.organization$);

    if (organization()) {
        router.navigate(['/']);
        return false;
    }

    return true;
};
